/* eslint-disable no-undef */
export default class PlayYouTubeVideo {
    constructor(videoSlide, idx) {
        this.index = idx;
        this.player = "";
        this.videoSlideWrap = videoSlide;
        this.videoPoster = this.videoSlideWrap.querySelector(
            ".jsSliderMainSlidePoster"
        );
        this.videoContainer = this.videoSlideWrap.querySelector(
            ".jsSliderMainSlideVideo"
        );
        if (this.videoSlideWrap && this.videoPoster && this.videoContainer) {
            this.videoId = this.videoContainer.dataset.videoId;
            this.videoContainer.id = `video-container-id-${this.index}`;
            if (this.videoId) {
                this.events();
            }
        }
        this.pageUrl = window.global.site_url;
    }

    events() {
        window.YT.ready(() => {
            this.setupYouTubePlayer();
        });
    }

    setupYouTubePlayer() {
        const self = this;

        this.player = new window.YT.Player(`${self.videoContainer.id}`, {
            videoId: `${self.videoId}`,
            width: 1280,
            height: 720,
            playerVars: {
                autoplay: 1,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                fs: 0,
                loop: 1,
                modestbranding: 1,
                origin: self.pageUrl,
                playlist: `${self.videoId}`,
                playsinline: 1,
                rel: 0,
                showinfo: 0,
            },
            events: {
                onReady: self.prepareYouTubeVideo.bind(self),
                onStateChange: self.playYouTubeVideo.bind(self),
            },
        });
    }

    prepareYouTubeVideo(event) {
        event.target.mute();
        event.target.setPlaybackQuality("hd720");
        event.target.playVideo();
        this.videoSlideWrap.classList.add("video-is-playing");
    }

    playYouTubeVideo(event) {
        // eslint-disable-next-line no-unused-vars
        const videoStatuses = Object.entries(window.YT.PlayerState);
        // console.log(
        //     videoStatuses.find((status) => status[1] === event.data)[0]
        // );
    }
}
